"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InboundSwitchTrackerKapiData = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../shared/core");
var InboundSwitchTrackerUI_1 = require("./ui/InboundSwitchTrackerUI");
var filterOnboardingSupplyMeters = function (supplyMeterInfos) {
    return supplyMeterInfos.filter(function (supplyMeterInfo) { return supplyMeterInfo.states.isOnboarding; });
};
var InboundSwitchTrackerKapiData = function (_a) {
    var combinedSupplies = _a.combinedSupplies;
    var _b = (0, core_1.useComponents)(), ErrorSection = _b.ErrorSection, Tabs = _b.Tabs, TabList = _b.TabList, Tab = _b.Tab, TabPanel = _b.TabPanel, Card = _b.Card, Icon = _b.Icon;
    var onboardingSupplyMeters = filterOnboardingSupplyMeters(__spreadArray(__spreadArray([], __read(combinedSupplies.electricity), false), __read(combinedSupplies.gas), false));
    if (onboardingSupplyMeters.length === 0) {
        return (react_1.default.createElement(ErrorSection, { id: "no-supplies", "data-testid": "omr-no-supplies-error" }));
    }
    if (onboardingSupplyMeters.length === 1) {
        var _c = onboardingSupplyMeters[0], fuel = _c.fuel, startDate = _c.startDate, states = _c.states;
        return (react_1.default.createElement(Card, { "data-testid": "single-supply-inbound-switch-tracker-".concat(fuel.toLowerCase()) },
            react_1.default.createElement(InboundSwitchTrackerUI_1.InboundSwitchTrackerUI, { supplyStartApiDate: startDate, meterHasSubmittedOmrs: states.hasSubmittedOmrs })));
    }
    var multipleElecOnboarding = onboardingSupplyMeters.filter(function (supplyMeter) { return supplyMeter.fuel === 'electricity'; }).length > 1;
    var multipleGasOnboarding = onboardingSupplyMeters.filter(function (supplyMeter) { return supplyMeter.fuel === 'gas'; })
        .length > 1;
    return (react_1.default.createElement(Tabs, { "data-testid": "multiple-supply-inbound-switch-tracker", fullWidth: "always" },
        react_1.default.createElement(TabList, null, onboardingSupplyMeters.map(function (supply) { return (react_1.default.createElement(Tab, { "data-testid": "multiple-supply-inbound-switch-tracker-tab-".concat(supply.fuel.toLowerCase()), key: supply.sprn },
            react_1.default.createElement(Icon, { name: supply.fuel.toLowerCase() }),
            " ",
            supply.fuel,
            (multipleElecOnboarding || multipleGasOnboarding) &&
                " (".concat(supply.sprn, ")"))); })),
        onboardingSupplyMeters.map(function (_a) {
            var sprn = _a.sprn, startDate = _a.startDate, states = _a.states;
            return (react_1.default.createElement(TabPanel, { key: sprn },
                react_1.default.createElement(InboundSwitchTrackerUI_1.InboundSwitchTrackerUI, { supplyStartApiDate: startDate, meterHasSubmittedOmrs: states.hasSubmittedOmrs })));
        })));
};
exports.InboundSwitchTrackerKapiData = InboundSwitchTrackerKapiData;
